import * as Yup from "yup";

export const loginInitialState = {
  email: "",
  password: "",
};

export const loginValidationSchema = Yup.object({
  email: Yup.string().required("Debes ingresar un correo."),
  password: Yup.string().required("Debes ingresar una contraseña."),
});
